var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_183",
    "data-name": "Ret\\xE2ngulo 183",
    width: 58,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discover",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discover-2",
    "data-name": "discover"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_580",
    "data-name": "Grupo 580",
    transform: "translate(10 16.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_232",
    "data-name": "Caminho 232",
    d: "M37.578,71.713H38.8v6.66H37.584Zm6.66,3.33a3.278,3.278,0,0,0,3.33,3.33,4,4,0,0,0,1.548-.332V76.6a2,2,0,0,1-1.548.666,2.074,2.074,0,0,1-2.114-2.214,2.13,2.13,0,0,1,2.114-2.214,2.358,2.358,0,0,1,1.548.666V72.053a4.2,4.2,0,0,0-1.548-.45,3.52,3.52,0,0,0-3.332,3.44Zm14.868,1-1.782-4.328H56l2.78,6.66h.666l2.78-6.66H60.894Zm3.662,2.33h3.546V77.257H63.982V75.493H66.2V74.377H63.982V72.829h2.33V71.713H62.768ZM71.2,73.711a1.938,1.938,0,0,0-2.214-2H67.1v6.66H68.32V75.709h.116l1.782,2.664h1.548l-2-2.78A1.82,1.82,0,0,0,71.2,73.711Zm-2.564,1.116H68.3v-2h.332c.782,0,1.216.332,1.216,1,.024.55-.308,1-1.208,1ZM33.682,71.713H31.8v6.66h1.782a3.3,3.3,0,0,0,3.446-3.33,3.108,3.108,0,0,0-3.346-3.33Zm-.332,5.56h-.332V72.829h.45A2.124,2.124,0,0,1,35.8,75.043a2.146,2.146,0,0,1-2.452,2.232Zm8.774-3c-.782-.332-1-.45-1-.782,0-.45.45-.666.882-.666a1.2,1.2,0,0,1,1,.55l.666-.882a2.454,2.454,0,0,0-1.882-.782,1.9,1.9,0,0,0-2,1.882c0,.882.45,1.332,1.548,1.782.666.216,1.216.45,1.216,1a.908.908,0,0,1-1,.882,1.446,1.446,0,0,1-1.332-.882l-.782.782a2.334,2.334,0,0,0,2.214,1.216,2.064,2.064,0,0,0,2.214-2.114c.036-.982-.414-1.432-1.746-1.982Z",
    transform: "translate(-31.8 -71.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    cx: 3.33,
    cy: 3.33,
    r: 3.33,
    transform: "translate(17.764 0.11)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.cf801577a867cfa4f25a31cb2b1a03e6.svg";
export { ForwardRef as ReactComponent };